import { render, staticRenderFns } from "./AgendamentosAdmin.vue?vue&type=template&id=5a9ad1a4&scoped=true"
import script from "./AgendamentosAdmin.vue?vue&type=script&lang=js"
export * from "./AgendamentosAdmin.vue?vue&type=script&lang=js"
import style0 from "./AgendamentosAdmin.vue?vue&type=style&index=0&id=5a9ad1a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9ad1a4",
  null
  
)

export default component.exports